// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3IeRn","primary":"Button_primary__2Bum4","secondary":"Button_secondary__GSwc7","tertiary":"Button_tertiary__3kB52","icon":"Button_icon__3-Dgb"};